export enum VisibilityScope {
  private = 'VISIBILITY_SCOPE_PRIVATE',
  public = 'VISIBILITY_SCOPE_PUBLIC',
}

// 阶段
export enum ProgressStatus {
  unknown = 'PROGRESS_STATUS_UNKNOWN',
  lead = 'PROGRESS_STATUS_LEAD',
  potential = 'PROGRESS_STATUS_POTENTIAL',
  order = 'PROGRESS_STATUS_ORDER',
};

// 线索阶段状态
export enum CleaningStatus {
  unknown = 'CLEANING_STATUS_UNKNOWN',
  pending = 'CLEANING_STATUS_PENDING',
  valid = 'CLEANING_STATUS_VALID',
  invalid = 'CLEANING_STATUS_INVALID',
  tempNotValid = 'CLEANING_STATUS_TEMPNOTVALID',
  continuable = 'CLEANING_STATUS_CONTINUABLE',
};

// 商机状态
export enum PotentialStatus {
  new = 'POTENTIAL_STATUS_NEW',
  normal = 'POTENTIAL_STATUS_NORMAL',
};

// 商机阶段状态
export type TransactionProbability = 0 | 20 | 40 | 60 | 80;

// 订单阶段状态
export enum OrderStatus {
  submitted = 'ORDER_STATUS_SUBMITTED',
  paid = 'ORDER_STATUS_PAID',
  unpaid = 'ORDER_STATUS_UNPAID',
  review = 'ORDER_STATUS_REVIEW',
  online = 'ORDER_STATUS_ONLINE',
  notOnline = 'ORDER_STATUS_NOT_ONLINE',
  unassigned = 'ORDER_STATUS_REGISTRATION_UNASSIGNED',
  withdrawed = 'ORDER_STATUS_REGISTRATION_WITHDRAWED',
  closed = 'ORDER_STATUS_REGISTRATION_CLOSED',
};
